import { setter } from "./setter";
import WidgetCommonMixin from "./WidgetCommonMixin.js";

export default {
  mixins: [WidgetCommonMixin],
  props: {
    field: {
      type: Object,
      default: () => {},
    },
    item: {
      type: Object,
      default: () => {},
    },
    fields: { type: Array, default: () => [] },
    design: { type: Boolean, default: false },
    selector: { type: Object, default: null },
    formState: { type: Object, default: null },
    disabled: { type: Boolean, default: false },
  },
  methods: {
    handleError: function (msg) {
      this.$emit("error", msg);
    },
    addEntry: function () {
      if (this.item) {
        if (this.field.code in this.item) {
          var newValues = [...this._current_values];
          newValues.push({});

          this.change(newValues);
        }
      }
    },
    close: function (entry_idx) {
      this._current_values.splice(entry_idx, 1);
    },
    changeRow: function (rowNo, value) {
      // Same as FormWidgetMixin.on_input
      if (!this.disabled) {
        var newValues = [...this._current_values];

        newValues[rowNo] = value; // Update the row

        this.change(newValues);
      }
    },
    change: function (value) {
      // Notify parent the Array changed.

      this.emitFieldChange("MultipleContainerMixin", value);
    },
    fieldsChanged: function (fields) {
      if (!this.disabled) {
        this.field.fields = fields;

        this.$emit("fields-change", this.fields);
      }
    },
  },
  computed: {
    the_item() {
      var val = this.item;

      if (val) {
        if (!(this.field.code in val)) {
          setter(this, val, this.field.code, null); // Ensure there is "a" key
        }

        return val;
      }
      return {};
    },
    _current_values() {
      // Get the current value safely...
      if (!this.item) {
        return [];
      }

      return this.item[this.field.code] || [];
    },
    atMax: function () {
      if (this.field.params.max) {
        if (this._current_values.length >= this.field.params.max) {
          return true;
        }
      }

      return false; // No Max so unlimited
    },
    atMin: function () {
      if (this.field.params.min) {
        return this._current_values.length <= this.field.params.min;
      }

      return false; // not min
    },
    all_items() {
      if (this.design) {
        return [{}]; // 1 item to see what it looks like!
      }

      return this._current_values;
    },
  },
  created: function () {
    if (this.item) {
      if (!(this.field.code in this.item)) {
        setter(this, this.item, this.field.code, []);
      }

      // Make sure minimum is achieved.
      while (this._current_values.length < this.field.params.min) {
        this.addEntry();
      }
    }
  },
};
